import localConfig from './config.local.json';
import stagingConfig from './config.staging.json';
import mainConfig from './config.main.json';
import devConfig from './config.dev.json';
import { Location } from '../constants/locations';
import { HostSlideConfigType } from '../constants/host-slides';
import { APP_ENV } from '../constants/env';

const configs = {
	local: localConfig,
	staging: stagingConfig,
	main: mainConfig,
	dev: devConfig,
};

export type AppConfig = {
	LOCATIONS?: Array<Location>;
	MAIN_PAGE_HOST_SLIDER?: Array<HostSlideConfigType>;
};

const appConfig: AppConfig = configs[APP_ENV || 'local'];

export default appConfig;
